<template>
    <div>
        <the-headersider></the-headersider>

        <div class="row">
<div class="col-sm-3">

</div>
<div class="col-sm-6">
    <div class="tile">
        <h4>Add Invoice Service</h4>
        <hr>
        <form @submit.prevent="createInvoice">

            <!-- <input type="hidden" name="csrfmiddlewaretoken" value="wScPQmOP3WhKgehT5px78tSnPyfb5tjfoqkpubfMWCyTdbm97tV271NE21lqwmh6"> -->
            <div class="form-group">
                <label>Description</label>
                <input type="text" name="service" class="form-control" v-model="formData.description">
            </div>
            <div class="form-group">
                <label>Quantity</label>
                <input type="number" name="quantity" class="form-control" v-model="formData.quantity">
            </div>


            <div class="form-group">
                <label>Unit Price</label>
                <input type="text" name="unit_price" class="form-control" v-model="formData.unity_price">
            </div>

            <div class="form-group">
                <label>Delivery Number</label>
                <input type="number" name="quantity" class="form-control" v-model="formData.delivery_number">
            </div>

            <button type="submit" class="btn btn-primary">Submit</button>
        </form>
    </div>

</div>
</div>



        
    


    </div>
</template>

<script>

  import axios from 'axios'
  export default {
    
      
      
   
    data() {
    
      return {
          user: '',
          
          formData: {
            description: '',
            quantity: '',
            unity_price:'',
            delivery_number:'',
            invoiceId: this.$route.params.number,
            
            
              
              
              
  
          },
          
       
        
      }
    },
    computed: {
          courts() {
              return  this.$store.getters.courts
  
              
          }
  
      },
       created() {
      this.$store.dispatch('LoadCourts');  
      
      
    },
      //  mounted() {
      // let user = localStorage.getItem('user');
      // this.user = JSON.parse(user)
  
      // },
    methods: {
      async createInvoice(){
        const response = await axios.post("https://api.roberms.com/garbage/create/service/", this.formData)
        console.log(response)
     
          this.$router.replace('/invoice/services/'+this.$route.params.number);
          console.log(this.formData)
  
      
  
      },
      
    },
    
  };
  </script>